import { Link } from "react-router-dom";
import { PublicLayout } from "@/components/PublicLayout";
import { Button } from "@/components/ui/button";
import { ListPlus, ArrowRight, CheckCircle2 } from "lucide-react";

const STEPS = [
  "Head to the Book Online page and choose the class at your child's school.",
  "If the class is full, you'll see a clear message and the form will switch to waiting-list mode — no payment is taken.",
  "Enter your child's name and your contact details, then submit to join the waiting list.",
  "As soon as a space becomes available, Vickie will contact you to confirm your child's place.",
];

export default function WaitingList() {
  return (
    <PublicLayout>
      <div className="bg-primary text-white py-12 px-4 text-center">
        <ListPlus className="mx-auto mb-4" size={44} />
        <h1 className="font-display text-5xl uppercase">Waiting List</h1>
        <p className="mt-3 text-white/90 max-w-2xl mx-auto text-lg">
          Is your child's class full? Don't worry — you can still join the waiting list and we'll be in touch the
          moment a space opens up.
        </p>
      </div>

      <div className="max-w-3xl mx-auto px-4 py-12">
        <h2 className="font-display text-3xl text-primary text-center mb-8">How it works</h2>
        <div className="space-y-4">
          {STEPS.map((s, i) => (
            <div key={i} data-testid={`waitlist-step-${i}`} className="flex items-start gap-4 rounded-2xl border border-border p-5">
              <div className="shrink-0 w-9 h-9 rounded-full bg-primary text-white font-display flex items-center justify-center">{i + 1}</div>
              <p className="text-slate-700 leading-relaxed">{s}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-3xl bg-primary/5 border border-primary/15 p-8 text-center">
          <CheckCircle2 className="mx-auto text-primary" size={36} />
          <p className="mt-3 text-slate-700 text-lg">
            Ready to join? Select your class on the Book Online page — if it's full, you'll be guided straight to the
            waiting list.
          </p>
          <Link to="/book-online">
            <Button data-testid="waitlist-book-btn"
              className="mt-6 rounded-full font-display text-2xl px-12 py-7 bg-primary text-white hover:bg-primary/90 hover:-translate-y-1 transition-transform shadow-xl">
              Go to Book Online <ArrowRight className="ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </PublicLayout>
  );
}
